module.exports = __webpack_public_path__ + "img/open-account-guide.378f2883.svg";